import useReveal from '@/hooks/useReveal';
import shared from '@/styles/public.module.css';
import styles from './LedgerSection.module.css';

// Legally reviewed copy — REDESIGN.md §4.6. Do not reword.
const ROWS = [
  {
    key: 'Your advance',
    title: 'You receive the full advance',
    body: 'Your approved advance is never reduced by platform or broker fees. Those fees are added to the funding balance and are only repaid if your case results in a recovery.',
  },
  {
    key: 'Our role',
    title: "We help you compare competing offers.",
    body: "MyCaseLoan isn't a funding company. Independent funders review your case, compete for your business, and make offers directly to you.",
  },
  {
    key: 'Your data',
    title: "Your case file isn't for sale",
    body: "Funders on the platform see your case in order to bid on it. We don't sell your information to lead buyers, marketers, or anyone else.",
  },
  {
    key: 'The math',
    title: 'One number, in dollars, before you sign',
    body: "Every offer states the total you'd repay at settlement — not just a percentage. If the wording confuses you, we'll walk your attorney through it.",
  },
];

const LedgerSection = () => {
  const ref = useReveal(shared.rv, shared.revealed);

  return (
    <section
      id="open"
      className={`${shared.section} ${shared.sectionPanel}`}
      ref={ref}
      data-testid="ledger-section"
    >
      <div className={`${shared.wrap} ${styles.grid}`}>
        <div className={`${shared.secHead} ${styles.head} ${shared.rv}`}>
          <span className={shared.eyebrow}>Straight answer</span>
          <h2>Legal funding shouldn&rsquo;t be confusing. Here&rsquo;s exactly how it works.</h2>
          <p>
            We&rsquo;re committed to making every part of the process clear, from how offers are made to what you&rsquo;ll receive and what you&rsquo;ll repay. Here&rsquo;s exactly how MyCaseLoan works.
          </p>
        </div>

        <div className={`${styles.ledger} ${shared.rv}`}>
          {ROWS.map((row) => (
            <div key={row.key} className={styles.row}>
              <div className={styles.key}>{row.key}</div>
              <div>
                <h3>{row.title}</h3>
                <p>{row.body}</p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default LedgerSection;
